<template>
  <v-container>
    <page-header :title="lang.releases" :info="format" />
    <div hidden v-if="format" v-html="`${lang.releases}, ${format}`" :class="['meta-description']" />
    <v-card v-if="items.length">
      <v-card-text>
        <v-list three-line>
          <template v-for="(item, index) in items">
            <v-list-tile ripple :key="index" :title="lang.viewMoreInfo(item.release)" :to="`/albums/${item.info.id}`">
              <v-list-tile-avatar v-if="item.cover" :size="64" :class="['mt-1', 'mr-4']">
                <img :src="item.cover" :alt="item.cover" />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-html="item.release" />
                <v-list-tile-sub-title v-html="item.band" />
                <v-list-tile-sub-title :class="['hidden-md-and-down']" v-html="lang.albumDetails(item.info)" />
              </v-list-tile-content>
              <chevron-right />
            </v-list-tile>
            <v-divider :key="index + '-divider'" v-if="index < items.length - 1" />
          </template>
        </v-list>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import lang from '../helpers/lang'
import methods from '../helpers/methods'

export default {
  name: 'releases-format',
  mixins: [
    methods
  ],
  data () {
    return {
      lang,
      format: null,
      items: []
    }
  },
  watch: {
    /**
     * route.params.format watcher
     */
    '$route.params.format' () {
      this.onMounted()
    }
  },
  mounted () {
    this.onMounted()
  },
  methods: {
    /**
     * Mounted event handler
     * @method onMounted
     * @return {void}
     */
    onMounted () {
      this.format = this.$route.params.format
      const cache = this.getCachedPage('releases', this.format, 'items')
      cache ? this.done(cache) : this.getReleasesData()
    },
    /**
     * Get the page data from the API
     * @method getReleasesData
     * @return {void}
     */
    getReleasesData () {
      const url = this.$root.routes.find(route => route.url.includes('releases/:')).url.replace(':format', encodeURIComponent(this.format))
      this.$http(url)
        .then(response => {
          this.done(response.data.payload.items)
        })
    },
    /**
     * Process the data from API or from the cache
     * @method done
     * @param {object} response [response=null]
     * @return {void}
     */
    done (response = null) {
      this.items = response
      this.$nextTick(() => {
        this.emitRouteChange()
        this.$nextTick(() => {
          this.setLastBreadcrumbsItemText(this.format)
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/releases-format.vue